import React from 'react';
import './SpeciesBox.css';
import './InfoBox.css';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import Box from './Box';

export const SpeciesBox: React.FC<SpeciesProps> = ({
  selected,
  selectedImage,
}) => {

  if (!selected) {
    return null;
  }

  const entryToShow = { title: selected.name, content: selected.data.description };

  return (
    <Box 
      selectedImage={selectedImage}
      textContentProps={entryToShow}
    />
  );
};


const mapStateToProps = (state: RootState) => ({
  selected: state.uiControl.selectedSpecies,
  selectedImage: state.uiControl.selectedImage,
});

type SpeciesProps = ReturnType<typeof mapStateToProps>;

export default connect(
  mapStateToProps,
)(SpeciesBox);